<template>
  <!--
    Popup de campanha: a arte carrega o visual/texto.
    Fecha no X, no backdrop ou com ESC.
  -->
  <div
    v-if="visible"
    class="campaign-popup"
    role="dialog"
    aria-modal="true"
    :aria-label="alt || 'Comunicado'"
    @click.self="close"
  >
    <div class="campaign-popup__dialog" role="document">
      <button
        type="button"
        class="campaign-popup__close"
        aria-label="Fechar"
        @click="close"
      >
        &times;
      </button>

      <picture>
        <source media="(max-width: 767px)" :srcset="imageMobile || image" />
        <img class="campaign-popup__img" :src="image" :alt="alt" />
      </picture>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignPopup',
  props: {
    visible: { type: Boolean, default: false },
    image: { type: String, required: true },
    imageMobile: { type: String, default: '' },
    alt: { type: String, default: '' },
  },
  watch: {
    visible: {
      immediate: true,
      handler(isOpen) {
        if (typeof document === 'undefined') return;
        document.body.style.overflow = isOpen ? 'hidden' : '';
      },
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKeydown(e) {
      if (this.visible && (e.key === 'Escape' || e.key === 'Esc')) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.campaign-popup {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(24px, env(safe-area-inset-top)) 24px max(24px, env(safe-area-inset-bottom));
  box-sizing: border-box;
  background: rgba(15, 18, 16, 0.55);
}

.campaign-popup__dialog {
  position: relative;
  width: min(520px, 86vw);
  max-height: min(72dvh, 560px);
  border-radius: 14px;
  overflow: hidden;
  background: transparent;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.26);
}

.campaign-popup__img {
  display: block;
  width: 100%;
  height: auto;
  max-height: min(70dvh, 540px);
  object-fit: contain;
  object-position: center;
}

.campaign-popup__close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #333438;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

@media (max-width: 767px) {
  .campaign-popup {
    padding: 28px 22px;
    align-items: center;
    justify-content: center;
  }

  .campaign-popup__dialog {
    width: min(340px, 84vw);
    max-width: 340px;
    max-height: min(68dvh, 520px);
  }

  .campaign-popup__img {
    max-height: min(66dvh, 500px);
  }
}
</style>
